import styled from 'styled-components'

export const Div = styled.div`
  margin: 0;
  width: 100%;
  min-height: 5em;
  color: white;
  padding: 0.625em;
  font-family: 'Roboto', sans-serif;
  background-color: ${props => props.theme};
`

export const P = styled.div`
  width: 60%;
  margin: 0;
  padding: 0.625em;
`



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/styles/AddressContainer.js